<template>
  <main class="content-holder d-flex align-items-center p-0">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md3>
          <v-card class="elevation-12">
            <v-toolbar>
              <v-toolbar-title>{{ $t('login.authorization') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <div class="i18n-menu">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <country-flag :country="currentLang.flag" size="normal" />
                    </v-btn>
                  </template>
                  <v-list>
                    <div v-for="item in languages" :key="item.lang">
                      <v-btn icon @click="updateLang(item)">
                        <country-flag :country="item.flag" size="normal" />
                      </v-btn>
                    </div>
                  </v-list>
                </v-menu>
              </div>
            </v-toolbar>
            <v-card-text class="text-center">
              {{ $t('login.googleAuth') }}
            </v-card-text>
            <v-card-actions class="justify-content-center py-4">
              <v-btn
                @click="firebaseAuth"
                ref="googleAuth"
                :disabled="entering"
                class="circle"
              >
                <span v-if="!entering"
                  ><img src="../assets/icons8-google-32.png" class="login-icon"
                /></span>
                <spinner v-else :size="30" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
</template>

<script>
import axios from '@/services/axios'
import firebase from 'firebase'
import i18n from '@/plugins/i18n'

export default {
  name: 'Login',
  components: {
    spinner: async () => await import('../components/Spinner.vue'),
  },
  data: () => ({
    entering: false,
  }),
  mounted() {
    this.$store.commit('resetStore')
  },
  methods: {
    updateLang(lang) {
      this.$store.dispatch('updateLang', lang)
    },
    tryLoginToBackend(idToken, userSettings) {
      this.entering = true

      console.log('Пытаемся залогиниться по адресу ' + this.serverEndpoint)
      axios
        .get('/UserInfo', {
          params: {
            barcode: userSettings.barcode,
            pin: userSettings.pin,
          },
        })
        .then(resp => {
          if (resp && resp.data) {
            this.$store.dispatch(
              'updateUserData',
              Object.assign(this.$store.state.userData, {
                token: resp.data.token,
                userId: resp.data.userId,
                userName: resp.data.userName,
              })
            )
            this.$store.dispatch('initApp')
            this.$emit('showSnack', {
              color: 'info',
              multiLine: true,
              text: `${this.loginTexts.logInAs} ${resp.data.userName}. ${this.loginTexts.waitFor}`,
            })
          }
        })
        .catch(e => {
          console.error('get/UserInfo error: ', e)
          //debugger
          this.$emit('showSnack', {
              color: 'error',
              multiLine: true,
              text: e + ' barcode:' + userSettings.barcode + ' pin:' + userSettings.pin,
            })
          this.entering = false
        })
        // .finally(() => (this.entering = false))
    },
    async firebaseAuth() {
      this.entering = true
      let provider = new firebase.auth.GoogleAuthProvider()
      const idToken = await firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => result.user)
        .then(user => user.getIdToken())
        .catch(error => {
          var errorMessage = error.message
          const message = `${this.loginTexts.authError}: ${errorMessage}`
          console.error(message, error)
          this.$emit('showSnack', { color: 'error', text: message })
        })

      if (!idToken) {
        this.entering = false
        return
      }

      let functions = new firebase.functions()
      const userSettings = await functions
        .httpsCallable('getUserProfile')({ idToken })
        .then(res => {
          if (!res.data.userSettings) {
            this.$emit('showSnack', {
              color: 'error',
              text: `Настройки для пользователя ${res.data.param} не найдены`,
            })
            return null
          }
          return res.data ? res.data.userSettings : null
        })
      .catch(err=>{
        console.error(err)
        //debugger
      })

      if (!userSettings) {
        this.entering = false
        return
      }
      const { serverAddress, APIAddress } = userSettings

      if (!serverAddress) {
        this.entering = false
        return
      }
      this.$store.dispatch('updateUserData', userSettings)

      this.$store.commit('updateServerAddress', serverAddress)
      this.$store.commit('updateAPIAddress', APIAddress)

      if (userSettings.groupUser) {
        this.$router.push({ name: 'GroupLogin' })
        return
      }
      this.$nextTick(() => {
        this.tryLoginToBackend(idToken, userSettings)
      })
    },
  }, //methods
  computed: {
    loginTexts: function() {
      return i18n.messages[i18n.locale].login
    },
    serverEndpoint: function() {
      return this.$store.getters.serverEndpoint
    },
    languages: function() {
      return this.$store.state.languages
    },
    currentLang: function() {
      return this.$store.state.lang
    },
  },
  watch: {
    currentLang: function() {
      i18n.locale = this.currentLang.lang
      let locale = this.currentLang.lang
      if (locale === 'ua') locale = 'uk'
      this.$vuetify.lang.current = locale
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/breakpoints';
.content-holder {
  display: flex;
  min-height: 100vh;
  height: 100vh;
}
h3 {
  font-size: 18px;
  @include sm {
    font-size: 15px;
  }
}
h4 {
  font-size: 11px;
  @include sm {
    font-size: 8px;
  }
}
.v-btn.circle {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  padding: 0;
  flex: 0 0;
  outline: none;
  box-shadow: none;
  min-width: auto;
}
</style>
